export { default as useIsFirstRender } from './useIsFirstRender';
export * from './useIsFirstRender';
//# sourceMappingURL=index.js.map